import classNames from 'classnames'
import React from 'react'

import Link from '@/components/link/link'
type BackButtonProps = {
  url: string
  label: string
  className?: string | null
}

const BackButton: React.FC<BackButtonProps> = ({
  url,
  label,
  className = null
}) => (
  <div className={classNames(className)}>
    <Link to={`${url}`}>{label}</Link>
  </div>
)

export default BackButton
